import React from "react";
import { useHistory } from "react-router";

function isBlockedByAdmin(item) {
  if (item?.considerAdminChanges) {
    if (item?.blockedByAdmin === 1) {
      return true;
    }
  }
  return false;
}

// function getCategoryStatus(item) {
//     if (item?.status === 0) {
//         return ['text-success border-success icon-check-fill', 'text-blue-50 icon-ban', 'text-blue-50 icon-info-triangle-fill']
//     } else if (item?.status === 1) {
//         return ['text-blue-50 icon-check-fill', 'text-blue-50 icon-info-triangle-fill', 'text-danger border-danger icon-ban']
//     } else if (item?.status === 2) {
//         return ['text-blue-50 icon-check-fill', 'text-warning border-warning icon-info-triangle-fill', 'text-blue-50 icon-ban']
//     } else {
//         return ['text-blue-50', 'text-blue-50', 'text-blue-50']
//     }
// }

function getCategoryStatus(item) {
  if (isBlockedByAdmin(item)) {
    return [
      "text-blue-50 icon-check-fill",
      "text-blue-50 icon-info-triangle-fill",
      "text-danger border-danger icon-ban",
    ];
  } else if (item?.categoryStatus === 0) {
    return [
      "text-success border-success icon-check-fill",
      "text-blue-50 icon-info-triangle-fill",
      "text-blue-50 icon-ban",
    ];
  } else if (item?.categoryStatus === 1) {
    return [
      "text-blue-50 icon-check-fill",
      "text-blue-50 icon-info-triangle-fill",
      "text-danger border-danger icon-ban",
    ];
  } else if (item?.categoryStatus === 2) {
    return [
      "text-blue-50 icon-check-fill",
      "text-warning border-warning icon-info-triangle-fill",
      "text-blue-50 icon-ban",
    ];
  } else {
    return ["text-blue-50", "text-blue-50", "text-blue-50"];
  }
}

const AppCategoryRow = ({
  item,
  handleAppCategoryChange,
  getLangTranslation,
  handleCategoryStatusChange,
  deviceSelected,
}) => {
  const history = useHistory();
  return (
    <tr>
      <td className="v-middle">
        <div className="form-check">
          {/*<input
                        className="form-check-input"
                        type="checkbox"
                        id={item?.id}
                        name={item?.id}
                        checked={item?.isChecked || 0}
                        onChange={(e) => handleAppCategoryChange(e)}
    />*/}
          <label className="form-check-label text-uppercase" htmlFor={item?.id}>
            {item?.name}
          </label>
        </div>
      </td>
      <td className="v-middle">
        <div className="d-inline-flex align-items-center gap-6">
          {getCategoryStatus(item)?.map((icon, index) => {
            return (
              <i
                className={`icon-check-fill fs-5 border rounded-circle ${icon}`}
                key={index}
              />
            );
          })}
          {/* <i className={`icon-check-fill fs-5 border rounded-circle ${getCategoryStatus(item)}`} />
                    <i className={`icon-info-triangle-fill fs-5 border rounded-circle ${getCategoryStatus(item)}`} />
                    <i className={`icon-ban fs-5 border rounded-circle ${getCategoryStatus(item)}`} /> */}

          <div className="dropdown">
            <i
              className="icon-three-dots fs-2 pt-cursor text-gray"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                onClick={() =>
                  handleCategoryStatusChange(
                    item,
                    item?.id,
                    "ALLOW",
                    deviceSelected
                  )
                }
              >
                {getLangTranslation("ALLOW", "ALLOW")}{" "}
              </li>
              <li
                className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                onClick={() =>
                  handleCategoryStatusChange(
                    item,
                    item?.id,
                    "BLOCK",
                    deviceSelected
                  )
                }
              >
                {getLangTranslation("BLOCK", "BLOCK")}{" "}
              </li>
              <li
                className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                onClick={() =>
                  handleCategoryStatusChange(
                    item,
                    item?.id,
                    "WARN",
                    deviceSelected
                  )
                }
              >
                {getLangTranslation("WARN", "WARN")}{" "}
              </li>
            </ul>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default AppCategoryRow;
